export default function ValidatedField({ id, label, error, required = true, ...inputProps }) {
  const errorId = `${id}-error`;
  return (
    <div className="form-field">
      <label htmlFor={id}>{label}{required && <span className="required-mark" aria-hidden="true">*</span>}</label>
      <input
        id={id}
        {...inputProps}
        required={required}
        aria-invalid={Boolean(error)}
        aria-describedby={error ? errorId : undefined}
        className={error ? 'input-error' : ''}
      />
      {error && <small className="field-error" id={errorId} role="alert">{error}</small>}
    </div>
  );
}
